var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.108,
    height: 28.842,
    viewBox: "0 0 25.108 28.842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-217.683,69.563c-.015-.025-.029-.054-.044-.083a3.872,3.872,0,0,1-.319-.309,3.551,3.551,0,0,1-.295-.329c-.073-.088-.142-.177-.206-.265s-.118-.157-.172-.241a6.068,6.068,0,0,1-.786-1.576,2.59,2.59,0,0,1-.088-.275,5.374,5.374,0,0,1-.2-1.228,2.422,2.422,0,0,1-.049-.589v-.1H-224.6v19a3.951,3.951,0,0,1-3.924,3.978h0a4,4,0,0,1-2.259-.737,4.1,4.1,0,0,1-1.67-3.207V83.46a3.987,3.987,0,0,1,3.924-3.919,3.865,3.865,0,0,1,1.08.147V74.783a8.194,8.194,0,0,0-1.129-.1,8.772,8.772,0,0,0-8.741,8.79,8.944,8.944,0,0,0,2.522,6.351.873.873,0,0,0,.179.18,8.843,8.843,0,0,0,5.156,2.367c.133.015.265.025.4.029s.29.01.432.01c.162,0,.324,0,.481-.015a8.614,8.614,0,0,0,6.443-3.521,8.927,8.927,0,0,0,1.768-5.3V73.8l.295.246a.685.685,0,0,0,.123.093,2.889,2.889,0,0,0,.246.182,9.952,9.952,0,0,0,.933.589c.231.118.462.236.7.339.118.054.241.1.363.147a9.023,9.023,0,0,0,3.182.565,4.66,4.66,0,0,0,.835-.049V73l.049-.034V71.194A6.367,6.367,0,0,1-217.683,69.563Z",
    transform: "translate(237.83 -64.068)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.af6f2563ab317e3baf9f9c8b2c07d25a.svg";
export { ForwardRef as ReactComponent };